import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '../../../../../hooks/use-query';
import Paginate from '../../../../../interfaces/paginate';
import Field from '../../../../../interfaces/field';
import { useService } from '../../../../../services/services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import css from '../../index.module.css';
import NewMap from './newmap';
import MapActionType from '../../../../../enums/map-action-type';

interface Props {
  setShowFullSize: Dispatch<SetStateAction<boolean>>;
  showFullSize: boolean;
  showFilter: boolean;
}

export default function FieldListMap({
  setShowFullSize,
  showFullSize,
  showFilter,
}: Props) {
  const { fieldService } = useService();
  const { farmId, season } = useParams<{ farmId: string; season: string }>();
  const [params, page, sort, desc] = useQuery();
  const [data, setData] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    fieldService
      .index(farmId, season, { page, sort, desc, ...params }, true)
      .subscribe((res: Paginate<Field>) => {
        setData(res.data);
        setMapLoaded(true);
      });
  }, [desc, farmId, fieldService, page, params, season, sort]);

  return data ? (
    <div
      className={`${css['map-container']} ${css['map-container-list-view']} ${
        showFilter && css['map-container-full-size']
      }`}
    >
      <NewMap
        key="field-list-map"
        data={data}
        triggerZoom
        type={MapActionType.default}
        mapLoaded={mapLoaded}
      />
      <div
        className={css['map-arrow']}
        onClick={() => setShowFullSize(!showFullSize)}
      >
        {showFullSize ? (
          <FontAwesomeIcon icon={faChevronRight} />
        ) : (
          <FontAwesomeIcon icon={faChevronLeft} />
        )}
      </div>
    </div>
  ) : null;
}
